<template>
    <a-card>
    <h3 style="text-align: center;margin:20px 0 40px">项目基本信息</h3>
        <a-descriptions size="middle" :column="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }" bordered={true}>
            <a-descriptions-item label="项目名称" name="projectName">{{form.projectName}}</a-descriptions-item>
            <a-descriptions-item label="所属年度" name="year">{{form.year}}</a-descriptions-item>
			<a-descriptions-item label="一级分类">
				<dict-render :dict-obj="dictObjs['projectTypeManage1']" :text="form.oneClassification" v-if="form.oneClassification"></dict-render>
			</a-descriptions-item>
            <a-descriptions-item label="二级分类">
				<dict-render :dict-obj="dictObjs['projectTypeManage2']" :text="form.twoClassification" v-if="form.twoClassification"></dict-render>
			</a-descriptions-item>
            <a-descriptions-item label="项目类别">
				<dict-render :dict-obj="dictObjs['techno_projectCategory']" :text="form.projectCategory" v-if="form.projectCategory"></dict-render>
			</a-descriptions-item>
            <a-descriptions-item label="所属领域">
				<dict-render :dict-obj="dictObjs['corpbelong_type']" :text="form.domain" v-if="form.domain"></dict-render>
			</a-descriptions-item>
            <a-descriptions-item label="技术领域">
				<dict-render :dict-obj="dictObjs['technical_field']" :text="form.technicalField" v-if="form.technicalField"></dict-render>
			</a-descriptions-item>
            <a-descriptions-item label="申报日期" name="year">{{form.declareTime}}</a-descriptions-item>
            <a-descriptions-item label="项目开始日期" name="year">{{form.startTime}}</a-descriptions-item>
            <a-descriptions-item label="项目结束日期" name="year">{{form.endTime}}</a-descriptions-item>

            <a-descriptions-item label="创新模式" name="innovationMode">{{form.innovationMode}}</a-descriptions-item>
        </a-descriptions>
    </a-card>
</template>

<script>

    import { projectBasicsInfo } from "@/api/TechnologieprojekteApply";
    import {
        dictMixin,
        formMixin
    } from "@/mixins";
    import DictRender from "@/components/other/DictRender";
    export default {
        name: "项目基本信息",
        mixins: [formMixin, dictMixin],
        components: {
            DictRender
        },
        data() {
            return {
                options: null,
                form:{
                    provject:null,
                },
                dictNames: "techno_projectCategory,corpbelong_type,projectTypeManage1,projectTypeManage2,technical_field",
            }
        },

        mounted() {
                this.getAction({
                    url: projectBasicsInfo.detail,
                    params: { 
                        id: this.$route.query.projectId
                     }
                }).then((res) => {
                        this.form = res
                });
        },
        methods: {
        }

    }
</script>
